// extracted by mini-css-extract-plugin
module.exports = {"section__bottom":"FPScheduleRecurringPayment_section__bottom_2kMwd"};